import { useId } from "react";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import { formFieldsPlaygroundFields as fields } from "./formFieldsPlayground.schema";
import { accessScopeOptions } from "./formFieldsPlaygroundChoice.schema";
import { lineKindOptions } from "./formFieldsPlaygroundLabelless.schema";
import { VariantGrid, VariantItem } from "./playgroundControls";
import styles from "./FormFieldsPlaygroundLabellessRows.module.scss";

/**
 * Kit fields without a visible label: `labelHidden` for an inline line-item
 * row, and `aria-labelledby` for fields named by a heading beside them.
 */
export const FormFieldsPlaygroundLabellessRows = () => {
    const accessHeadingId = useId();
    const depositHeadingId = useId();
    const receiptHeadingId = useId();

    return (
        <>
            <VariantGrid title="Label-less · labelHidden" columns="full">
                <VariantItem label="inline line-item row">
                    <HStack gap={12} align="start">
                        <fields.Text
                            name="labelless.description"
                            label="Description"
                            labelHidden
                        />
                        <fields.Money
                            name="labelless.amount"
                            label="Amount"
                            labelHidden
                        />
                        <fields.Date
                            name="labelless.date"
                            label="Date"
                            labelHidden
                        />
                        <fields.Select
                            name="labelless.kind"
                            label="Kind"
                            labelHidden
                            options={lineKindOptions}
                        />
                        <fields.Checkbox
                            name="labelless.isBillable"
                            label="Billable"
                            labelHidden
                        />
                    </HStack>
                </VariantItem>
            </VariantGrid>
            <VariantGrid title="Label-less · aria-labelledby" columns="wide">
                <VariantItem label="Radio">
                    <VStack gap={8}>
                        <h3 id={accessHeadingId} className={styles.heading}>
                            Guest access
                        </h3>
                        <fields.Radio
                            name="labelless.scope"
                            aria-labelledby={accessHeadingId}
                            options={accessScopeOptions}
                        />
                    </VStack>
                </VariantItem>
                <VariantItem label="FinancialAccount (error)">
                    <VStack gap={8}>
                        <h3 id={depositHeadingId} className={styles.heading}>
                            Deposit to
                        </h3>
                        <fields.FinancialAccount
                            name="labelless.depositAccountId"
                            aria-labelledby={depositHeadingId}
                        />
                    </VStack>
                </VariantItem>
                <VariantItem label="Switch">
                    <HStack gap={12} align="center">
                        <h3 id={receiptHeadingId} className={styles.heading}>
                            Email receipts
                        </h3>
                        <fields.Switch
                            name="labelless.isReceiptOn"
                            aria-labelledby={receiptHeadingId}
                        />
                    </HStack>
                </VariantItem>
            </VariantGrid>
        </>
    );
};
